import RetrieveBooking from './RetrieveBooking/RetrieveBooking';
import SegmentCommon from './SegmentCommon/SegmentCommon';
import MobileSegment from './MobileSegment/MobileSegment';
import Traveller from './Traveller/Traveller';
import SearchFormNotices from './SearchFormNotices/SearchFormNotices';
import RefundInfo from './RefundInfo/RefundInfo';
import PassengersCheckPopup from './Checkout/PassengersCheckPopup/PassengersCheckPopup';
import Warnings from './Checkout/Warnings/Warnings';
import MobileSegmentFlatTime from './MobileSegmentFlatTime/MobileSegmentFlatTime';
import Checkout from './Checkout/Checkout';
import MealServiceAdditionalInfo from './MealServiceAdditionalInfo/MealServiceAdditionalInfo';
import FlightCardAirlineInfo from './FlightCardAirlineInfo/FlightCardAirlineInfo';
import BaggageIcon from './Baggage/BaggageIcon/BaggageIcon';
import { payment } from './FareGroup/icons';
import { PetInCabin2, SnowBoard } from '@websky/core/src/Icons';
import FareGroupGridRulesButton from './FareGroupGridRulesButton/FareGroupGridRulesButton';
import { renderHeaderEquipmentIcon } from './HeaderEquipmentItem/icons';
import DisabilitiesPassengerNotification from './DisabilitiesPassengerNotification/DisabilitiesPassengerNotification';
import { Logo } from '../theme/images/Images';
import SimpleLoader from '../../../core/src/SimpleLoader';
import ProfileControls from './Account/ProfileControls/ProfileControls';
import RefundCreateTicket from './Refund/CreateTicket/CreateTicket';
import RefundWarningModal from './Refund/WarningModal/WarningModal';
import { renderExchangeLinksLabel, renderRefundLinksLabel } from './InfoLinksLabel/InfoLinksLabel';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
export var yamalRenderers = {
    renderRetrieveBooking: RetrieveBooking,
    renderSegmentCommon: SegmentCommon,
    renderMobileSegment: MobileSegment,
    renderTraveller: Traveller,
    renderPaymentIcon: function (type) { return payment[type]; },
    CheckoutSubsidyInfoPopup: PassengersCheckPopup,
    CheckoutWarnings: Warnings,
    SearchFormNotices: SearchFormNotices,
    RenderRefundInfo: RefundInfo,
    MobileSegmentFlatTime: MobileSegmentFlatTime,
    MealServiceAdditionalInfo: MealServiceAdditionalInfo,
    checkoutRender: Checkout,
    renderFlightCardAirlineInfo: FlightCardAirlineInfo,
    BaggageIcon: BaggageIcon,
    PetInHold: function () { return PetInCabin2; },
    Ski: function () { return SnowBoard; },
    FareGroupGridRulesButton: FareGroupGridRulesButton,
    renderHeaderEquipmentIcon: renderHeaderEquipmentIcon,
    DisabilitiesPassengerNotification: DisabilitiesPassengerNotification,
    MetasearchLoaderLogo: Logo,
    Welcome: SimpleLoader,
    AccountProfileControls: ProfileControls,
    RefundCreateTicket: RefundCreateTicket,
    RefundWarningModal: RefundWarningModal,
    renderExchangeLinksLabel: renderExchangeLinksLabel,
    renderRefundLinksLabel: renderRefundLinksLabel,
    CheckoutInsurance: OrderInsuranceBlockSlotUpsale
};
